<template>
  <div>
    <QrCodePdfVariant
      ref="html2Pdf2"
      :qrCodeValue="getQrCodeValue"
      :productData="productData"
    />
    <!-- <ProductImage @disable="disableDownloadImage()" :product="productData" :qrCodeValue="getQrCodeValue" :enableDownload = "enableImageDownload"/> -->
    <ProductImageVariant  @disable="disableDownloadImage()" :product="productData" :qrCodeValue="getQrCodeValue" :enableDownload = "enableImageDownload"/>

    <vue-html2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="true"
    :paginate-elements-by-height="1100"
    pdf-content-width="480px"
    :pdf-quality="3"
    :filename="'product-card.pdf'"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    ref="html2Pdf"
    :html-to-pdf-options="htmlToPdfOptions"
    @hasDownloaded="hasDownloaded()"
  >
    <template slot="pdf-content">
      <!-- <product-qr-ui :product="productData" :qrCodeValue="getQrCodeValue" :isPdf="true"/> -->
      <Product-qr-ui-variant v-bind:key="'pdf-qr-card'+variant.id" v-for="variant in productData.variants" :variant="variant" :product="productData" :qrCodeValue="getQrCodeValue" :isPdf="true" />
      
    </template>
    </vue-html2pdf>
    <v-dialog content-class="overflow-x-hidden" persistent :value="vg_productCardPop" @keydown.esc="closeModal()"
      width="unset">
      <v-card>
        <v-card-title>
          <span class="text-h5">Product QR</span>
        </v-card-title>
        <v-card-text>

          <product-qr-ui :product="productData" :qrCodeValue="getQrCodeValue" />
          <!-- <CustomQrUiImageVariant v-bind:key="'pdf-qr-card'+variant.id" v-for="variant in productData.variants" :variant="variant" :product="productData" :qrCodeValue="getQrCodeValue" :isPdf="true" /> -->

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeModal()">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="$refs.html2Pdf.generatePdf()">
            Download Pdf
          </v-btn>
          <v-btn @click="downloadImage()" color="primary" text >
            Download Image
          </v-btn>
          <v-btn color="primary" text @click="$refs.html2Pdf2.generatePdf()">
            QR Price PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import VueHtml2pdf from 'vue-html2pdf'
import { mapActions, mapGetters } from 'vuex'
import { LocationProductAPI } from '@/clients/location/location.product.api'
import ProductQrUi from '@/components/app-specific/ProductQrUi.vue'
import ProductQrUiVariant from '@/components/app-specific/ProductQrUiVariant.vue'
import CustomQrUiImageVariant from '@/components/app-specific/CustomQrUiImageVariant.vue'
import QrCodePdf from './QrCodePdf.vue';
import QrCodePdfVariant from './QrCodePdfVariant.vue';
import ProductImage from './ProductImage.vue';
import ProductImageVariant from './ProductImageVariant.vue';

export default {
  components: {
    ProductQrUi,
    ProductQrUiVariant,
    QrCodePdfVariant,
    // eslint-disable-next-line vue/no-unused-components
    VueHtml2pdf,
    QrCodePdf,
    ProductImage,
    ProductImageVariant,
    CustomQrUiImageVariant
},
  data() {
    return {
      loaded: true,
      productData: {},
      enableImageDownload: false
    }
  },
  async mounted() {

  },
  computed: {
    htmlToPdfOptions() {
      return {
        filename: this.productData.name || 'product',
        // image: { type: 'png', quality: 1 },
        image: { type: 'jpeg', quality: 0.55 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
          dpi: 192,
          scale: 2,
          letterRendering: true
        }
      }
    },
    background() {
      return this.vg_activeBusinessBrandingAndLogo.primary
    },
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo',
      vg_selectedLocation: 'location/selected',
      vg_selectedBusiness: 'auth/activeBusiness',
      vg_productCardPop: 'locationproduct/productCardPop',
      productObj: 'locationproduct/productObj',
      getAromas: 'aroma/list'
    }),
    getQrCodeValue() {
      return (
        process.env.VUE_APP_PRODUCT_QR_URL + '/' +
        this.vg_selectedBusiness.slug +
        '/' +
        this.vg_selectedLocation.slug +
        '/' +
        this.productData.id +
        '?in_store=true&noage=true'
      )
    }
  },
  watch: {
    async vg_productCardPop(val) {
      if (!val) return
      try {
        this.spinner(true)
        const { data: { payload } } = await LocationProductAPI.fetchProductDetails({ product_ids: [this.productObj.id] })
        this.productData = payload[0]
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.msg,
          open: true,
          color: 'error'
        })
        this.closeModal()
      }
    }
  },
  methods: {
    downloadImage() {
      this.setProductSelectionType('image')
      this.enableImageDownload = true
    },
    disableDownloadImage() {
      this.enableImageDownload = false
    },
    async closeModal() {
      this.enableImageDownload = false
      this.setProductCardDialogValue(false)
    },
    downloadPDF() {
      this.loaded = false
      // this.setProductSelectionType('pdf')
      this.$refs.html2Pdf.generatePdf()
    },
    hasDownloaded() {
      this.loaded = true
    },
    ...mapActions({
      setProductCardDialogValue: 'locationproduct/setProductCardDialogValue',
      setAromaList: 'aroma/setList',
      setProductSelectionType: 'locationproduct/setProductSelectionType'
    })
  }
}
</script>
